import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Examination } from "@/features/modules/examination/objects/Examination";
import { websocketClient } from "@/features/modules/assist/objects/WebsocketClient";

export const requestAttachments = (examination: Examination): void => {
  try {
    websocketClient.sendRequest("requestAttachments", { examinationId: examination.id });
  } catch (error: unknown) {
    appFaultModel.catchAppError("AssistModel.requestAttachments", { examination }, error);
  }
};
